import React from 'react';
import SettingsSidebar from '../components/Home/Admin/SettingsSidebar'

const SettingsLayout = ({ children }) => {
    return (
        <div className="chat-screens">
            <div className="outer-container">
                <div className="sidebar">
                    <SettingsSidebar />
                </div>
                <div className="chat-container">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default SettingsLayout;
